app.factory('ShoppingCart', ['$resource', function($resource) {
	const ShoppingCart = function() {
		this.order = $resource('/api/orders/:id', {id: '@id'});
		this.items = $resource('/api/order_items/:id', {id: '@id'}, {update: {method: 'PATCH'}});
	};

	ShoppingCart.prototype.get = function(id) {
		return this.order.get({id});
	};

	ShoppingCart.prototype.add = function(item) {
		return this.items.save({order_item: item});
	};

	ShoppingCart.prototype.update = function(item) {
		return this.items.update({id: item.id, order_item: item});
	};

	ShoppingCart.prototype.remove = function(item) {
		return this.items.remove({id: item.id});
	};

	return new ShoppingCart;
}
]);
